var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"columns"},[_c('SideBar',{staticClass:"menu-sidebar"}),_c('section',{staticClass:"qi-content"},[_vm._m(0),_c('vs-row',[_c('NewSale')],1),_c('Abas')],1)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v(" Minhas Pré-Matrículas ")])])
}]

export { render, staticRenderFns }